module.exports = __webpack_public_path__ + "img/gushi_3_new.9d5b1d6f.jpeg";